import { useState } from 'react';
import { APP_MODES, DEFAULT_APP_MODE } from '@shared';
import {
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@design-system';
import { PrimarySecondaryButtonContainer, SubmitButton } from '@/components/FormComponents';
import { FormErrorAlert } from '@/components/FormErrorAlert';
import { useUpdateAppMode } from '../hooks/use-update-app-mode';
import { getErrorMessage } from '../utils/get-error-message';

const APP_MODE_LABELS: Record<AppMode, string> = {
  standard: 'Standard',
  d2c: 'D2C',
};

export function AppModeField({
  advisorId,
  initialAppMode,
}: {
  advisorId: string;
  initialAppMode: AppMode | null;
}) {
  const [appMode, setAppMode] = useState<AppMode>(initialAppMode ?? DEFAULT_APP_MODE);
  const { updateAppMode, isPending, isError, error } = useUpdateAppMode();

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="appMode">App Mode</Label>
        <p className="text-foreground text-xs">
          The flow this advisor and all of their clients see.
        </p>
        <Select
          value={appMode}
          onValueChange={value => setAppMode(value as AppMode)}
        >
          <SelectTrigger
            id="appMode"
            className="w-full"
          >
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {APP_MODES.map(mode => (
              <SelectItem
                key={mode}
                value={mode}
              >
                {APP_MODE_LABELS[mode]}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <PrimarySecondaryButtonContainer>
        <SubmitButton
          label="Update App Mode"
          isLoading={isPending}
          onClick={() => updateAppMode({ advisorId, appMode })}
        />
      </PrimarySecondaryButtonContainer>

      {isError && (
        <FormErrorAlert
          mainErrorMessage={getErrorMessage(error, 'Failed to update app mode')}
          isWarning={true}
          className="mt-4"
        />
      )}
    </div>
  );
}
